module.exports = __webpack_public_path__ + "static/media/delete_cross.49f683b3.svg";